import css from 'styled-jsx/css';

const styles = css.global`.card-store {
  box-shadow: 0px 0px 0px 0px #ffffff00;
  border: 1px solid #cccccc;
  border-radius: 8px;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;

  padding: 16px;
  min-height: 164px;

  overflow: hidden;
  flex-grow: 1;
}

.card-store.area-clickable {
  cursor: pointer;
}

.card-store .card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.card-store .select-button {
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.card-store .select-button img {
  pointer-events: none;
}

.card-store .card-header-info {
  flex: 1;
  margin-left: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.card-store .card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 12px 0 0 24px;

  border-top: 1px dotted #cedee7;
  padding-top: 12px;
}

.card-store.checked {
  border-color: #cc0000;
  transition: border-color 300ms ease;
}

.card-store .card-name {
  font-family: 'SantanderMicroText';
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #222;
}

.card-store .card-distance {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #222;
}

.card-store .card-address {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
  color: #222;
  margin-bottom: 12px;
  white-space: pre-wrap;
}

.card-store .card-next {
  font-family: 'SantanderMicroText';
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 20px;
  min-width: 162px;
  width: fit-content;

  padding: 0 8px;
  margin-top: auto;

  background: #23779a;
  border-radius: 8px;
}
`;

export default styles;